import { connect } from 'react-redux';
import { getExternalData } from '../../../../../../core/slices/annualPlanV2';
import { saveActivitiesBatch } from '@/core/slices/activities';
import { fetchAnnualPlanStep2Context, markPlanVersionForApproval } from '@/core/slices/plans';
import {
  objectives,
  activities,
  requirements,
  focuses,
  currentVersion,
  annualPlanExternalData,
  isLoadingObjectives,
  isLoadingActivities,
  annualPlanV2ErrorMessage,
  readOnlyMode,
  selectedYear,
  scopeName,
  enterpriseName,
  currentPlanId,
  currentBusinessUnit,
  planRequirementDecisions,
} from '../../../../../../core/selectors';
import { RootState } from '../../../../../../core/types/state';
import DefineActivities from '../../../../components/AnnualPlanning/FirstTerm/DefineActivities';

const ConnectedDefineActivities = connect(
  (state: RootState) => ({
    objectives: objectives(state),
    activities: activities(state),
    requirements: requirements(state),
    focuses: focuses(state),
    currentVersion: currentVersion(state),
    externalData: annualPlanExternalData(state),
    isLoadingObjectives: isLoadingObjectives(state),
    isLoadingActivities: isLoadingActivities(state),
    errorMessage: annualPlanV2ErrorMessage(state),
    readOnlyMode: readOnlyMode(state),
    selectedYear: selectedYear(state),
    scopeName: scopeName(state),
    enterpriseName: enterpriseName(state),
    currentPlanId: currentPlanId(state),
    currentBusinessUnit: currentBusinessUnit(state),
    planRequirementDecisions: planRequirementDecisions(state),
  }),
  {
    fetchAnnualPlanStep2Context,
    saveActivitiesBatch,
    getExternalData,
    markPlanVersionForApproval,
  },
)(DefineActivities);

export default ConnectedDefineActivities;
